/**
 * Sticky Scroll Effect
 * Wraps two consecutive sections so that section 1 is sticky
 * and section 2 scrolls over it.
 * Section 1 scales down as section 2 overlaps, and scales back to 1 when in full view.
 */
(function () {
  const SECTION_1_ID = 'shopify-section-template--28405774877059__image_with_text_CMnC7h';
  const SECTION_2_ID = 'shopify-section-template--28405774877059__image_with_text_7nDJHG';
  const MIN_SCALE = 0.9;

  function init() {
    const section1 = document.getElementById(SECTION_1_ID);
    const section2 = document.getElementById(SECTION_2_ID);

    if (!section1 || !section2) return;

    // Create outer wrapper
    const wrapper = document.createElement('div');
    wrapper.classList.add('sticky-scroll-wrapper');

    // Insert wrapper before section 1
    section1.parentNode.insertBefore(wrapper, section1);

    // Move section 1 into wrapper and mark as sticky
    section1.classList.add('sticky-scroll-section');
    wrapper.appendChild(section1);

    // Create overlay group (section 2 with white bg)
    const overlayGroup = document.createElement('div');
    overlayGroup.classList.add('sticky-scroll-overlay-group');

    // Move section 2 into the overlay group
    overlayGroup.appendChild(section2);

    // Add overlay group to wrapper
    wrapper.appendChild(overlayGroup);

    // Skip scale effect on mobile
    if (window.innerWidth < 768) return;

    // Target the grid inside section 1, not the whole section
    var scaleTarget = section1.querySelector('.image-with-text__grid');
    if (!scaleTarget) return;

    // Scale the grid based on how much section 2 overlaps section 1
    function onScroll() {
      var s1Rect = section1.getBoundingClientRect();
      var ogRect = overlayGroup.getBoundingClientRect();

      // How much of section 1 is covered by the overlay
      var overlap = s1Rect.bottom - ogRect.top;

      if (overlap <= 0) {
        scaleTarget.style.transform = 'scale(1)';
        return;
      }

      var s1Height = s1Rect.height;
      if (s1Height <= 0) return;

      // progress: 0 = no overlap, 1 = fully covered
      var progress = Math.min(overlap / s1Height, 1);

      // Scale from 1 → MIN_SCALE
      var scale = 1 - progress * (1 - MIN_SCALE);
      scaleTarget.style.transform = 'scale(' + scale + ')';
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
